import * as tinymce from 'tinymce';

// Theme + icons
import "tinymce/themes/silver";
import "tinymce/icons/default";

import "tinymce/models/dom";


import "tinymce/skins/ui/oxide/skin.js";
import "tinymce/skins/ui/oxide/content.js";
import "tinymce/skins/content/default/content.js";


import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/autolink";
import "tinymce/plugins/charmap";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/image";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/media";
import "tinymce/plugins/preview";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/table";
import "tinymce/plugins/visualblocks";

import 'tinymce-premium/plugins/licensekeymanager';

export class TinyMCEHelper {
    public static initialize(selector: string, versionHistoryPopup : boolean = false): void {
        var toolbarButtons = 'undo redo | styles | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image';
        if(versionHistoryPopup) {
            toolbarButtons += ' | version-history-badges';
        }

       (tinymce as any).init({
            selector,

            height: '70vh',

            license_key: 'gpl',
            api_key: 'guoqzvdvfj4zu82fzlehby8vgdkh2liygbf89evx3av02i55',

            plugins: [
                "advlist", "anchor", "autolink", "charmap", "code", "fullscreen",
                "image", "insertdatetime", "link", "lists", "media",
                "preview", "searchreplace", "table", "visualblocks",
            ],
            toolbar: toolbarButtons,

            content_style: `
                body {
                    max-width: 793px;
                    margin: 0 auto;
                    padding: 40px 56px;
                    background: white;
                    font-family: Trebuchet MS;
                    font-size: 16px;
                }

                html {
                    background: #f3f4f6;
                }
            `,
            setup: (editor) => {
                editor.ui.registry.addMenuButton('version-history-badges', {
                    icon: 'suggestededits-badge',
                    tooltip: 'Version history badges',
                    fetch: (callback) => {
                        const items = [
                            {
                                type: 'menuitem',
                                text: 'New',
                                onAction: () => editor.insertContent(`<label class="version-history-new-badge">New</label>`)
                            },
                            {
                                type: 'menuitem',
                                text: 'Updated',
                                onAction: () => editor.insertContent(`<label class="version-history-updated-badge">Updated</label>`)
                            },
                            {
                                type: 'menuitem',
                                text: 'Fixed',
                                onAction: () => editor.insertContent(`<label class="version-history-danger-badge">Fixed</label>`)
                            }
                        ];
                        callback(items);
                    }
                });
            }
        });
    }

    public static triggerSave(): void {
        (tinymce as any).triggerSave();
    }

    public static remove(selector: string): void {
        (tinymce as any).remove(selector);
    }
}